// Loading real translations
// Put in a separate module so it can be replaced with NormalModuleReplacementPlugin
// on the static site (see loadIntlMessage.static.ts)
const loadIntlMessage = (locale: string) =>
  import(`../../../../locale/${locale}.json` /* webpackChunkName: "intl-message-[request]" */);

export default loadIntlMessage;
